import { joinURLPath } from '@sigma-frontend-libs/commons'
import { PROVIDER_STATES } from '@sigma-legacy-libs/essentials/lib/constants'

import { getSocket, globalErrorHandler, request, services, sizes } from '@/utils'

import render from './render'

export default {
  name: 'State',

  props: {
    id: {
      type: String,
      required: true
    },

    size: {
      type: String,
      default: sizes.small,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    }
  },

  data() {
    return {
      state: PROVIDER_STATES.inactive,
      loading: false,
      interval: null
    }
  },

  watch: {
    id() {
      this.getState()
    }
  },

  mounted() {
    const socket = getSocket()
    socket?.on(`${services.providers}.state.changed`, data => {
      if (this.id === data.providerId) {
        this.state = data.state
      }
    })

    this.getState()
    this.interval = setInterval(() => {
      return this.getState()
    }, 60 * 1000)
  },
  beforeDestroy() {
    const socket = getSocket()
    socket?.off(`${services.providers}.state.changed`)
    clearInterval(this.interval)
  },

  methods: {
    async getState(id) {
      try {
        this.loading = true
        const data = await request.get(joinURLPath(services.providers, this.id || id), undefined, { state: true })
        if (data && data.result) {
          this.state = data.result
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
